import {
  DocumentListSourceDetail,
  DocumentListSourceInfo,
  DocumentViewerListIdRequest,
} from '../../../../api/types/document.type';
import {SourceTypeCode} from '../../../../shared/constants';

export interface CreateDocumentViewerListRequestPayloadArgsFromTally {
  documentListMasterID: DocumentListSourceInfo['documentListMasterID'];
  sourceID: DocumentListSourceDetail['sourceID'];
  totalDocumentToView: DocumentListSourceInfo['totalDocumentToView'];
}

export const createDocumentViewerListRequestPayloadFromTally = (
  args: CreateDocumentViewerListRequestPayloadArgsFromTally
): DocumentViewerListIdRequest => {
  const objSource = {
    // Required
    totalDocumentToView: args.totalDocumentToView,
    sourceTypeCode: SourceTypeCode.TALLY,
    sourceDetails: [{sourceID: args.sourceID} as never],
    assignmentSource: '',
    selectedAssignmentName: '',
    isDefaultLoad: true,
    isDocumentCount: false,
    destinationContextTypeCode: 'DOCVIEW',
    documentListMasterID: args.documentListMasterID,
    userID: 0,
    securityGroupID: 0,
    roleID: 0,
    projectID: 0,
    docsToExclude: [],
    sqlUnitParam: [],
    columnFilters: [],
    destinationTypeCode: '',
    sampleMethod: '',
    stR_SelectedSearchIds: [],
    reportID: '',
    prevPageName: '',
    dataSetStatus: '',
    ...{},
  };

  return {
    objSource: objSource as never,
    docViewSessionObject: {
      sortconfiguration: {
        optimizedCols: '',
        optimizedSelectFieldIDs: '',
        optimizedSelectFieldOrder: '',
        manualCols: 'string',
        manualSelectFieldIDs: '',
        manualSelectFieldOrder: '',
        selectFields: '',
        configuredCols: '',
        order: '',
        showCompletedDocOptimized: false,
        showCompletedDocManual: false,
        configuredShowCompletedDoc: false,
        selectFieldTemp: '',
        selectFieldDataTypeOptimized: [],
        selectFieldDataType: [],
        selectFieldDataTypeManual: [],
        redirectionType: 0,
        manualOrder: '',
      },
      assignmentSortDetails: [
        {
          sourceID: args.sourceID,
          columnManual: '',
          columnOptimized: '',
          columnIDsOptimized: '',
          columnOrderOptimized: '',
          columnIDsManual: '',
          columnOrderManual: '',
          showCompletedOptimized: true,
          showCompletedManual: false,
          configuredShowCompletedDoc: false,
          columnDisplayManual: '',
          columnDataTypeOptimized: [],
          columnDataTypeManual: [],
        },
      ],
      sourceTypeCode: objSource.sourceTypeCode,
      backtoSrcSourceTypeCode: objSource.sourceTypeCode,
      sourceID: args.sourceID,
      backtoSrcSourceId: args.sourceID,
      assignmentSource: '',
      xmlCompletedDocumentEditedCodingForm: '',
      docsForCodeSame: [],
    } as never,
    sortConfigurationDocView: {
      optimizedCols: '',
      optimizedSelectFieldIDs: '',
      optimizedSelectFieldOrder: '',
      manualCols: 'string',
      manualSelectFieldIDs: '',
      manualSelectFieldOrder: '',
      selectFields: '',
      configuredCols: '',
      order: '',
      selectFieldTemp: '',
      selectFieldDataTypeOptimized: [],
      selectFieldDataType: [],
      selectFieldDataTypeManual: [],
      manualOrder: '',
    } as never,
    defaultAssName: '',
    sortConfigDocView: {
      optimizedCols: '',
      optimizedSelectFieldIDs: '',
      optimizedSelectFieldOrder: '',
      manualCols: '',
      manualSelectFieldIDs: '',
      manualSelectFieldOrder: '',
      selectFields: '',
      configuredCols: '',
      order: '',
      showCompletedDocOptimized: false,
      showCompletedDocManual: false,
      configuredShowCompletedDoc: false,
      selectFieldTemp: '',
      selectFieldDataTypeOptimized: [],
      selectFieldDataType: [],
      selectFieldDataTypeManual: [],
      manualOrder: '',
    } as never,
  } as never;
};
